export class FbGeneralButtonConfiguration {

    constructor(public label?: string, public action?: Function, public icon?: string, public posIcon? : string, public styleClass?: string, public disabled: boolean = false, public severity?:string) { }

    public static create = (label?: string, action?: Function) => new FbGeneralButtonConfiguration(label, action);

    setStyleClass(styleClass: string) {

        this.styleClass = styleClass;
        return this;

    }
    setIcon(icon: string) {

        this.icon = icon;
        return this;

    }

    setPosIcon(posIcon: string) {

        this.posIcon = posIcon;
        return this;

    }


    setDisabled(disabled: boolean) {

        this.disabled = disabled;
        return this;

    }
    
    setSeverity(severity:string){
        this.severity = severity;
        return this;
    }

}
